import React from 'react';
import { MdCopyright } from 'react-icons/md';
import { Container } from './styles';

export default function Footer() {
  return (
    <Container>
      <div>
        <MdCopyright />
        Drive On Subscriptions
      </div>
      <div>
        Developed with ♥ by: <a href="https://matgsan.dev">Matgsan</a>
      </div>
    </Container>
  );
}
